var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 64,
    viewBox: "0 0 58 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M52.0808 51.4158C45.6467 64.9691 31.5718 66.4103 18.4652 54.2327C5.20421 43.4135 -2.27182 26.1601 4.36879 13.5695C13.1217 1.21356 32.0219 -2.40441 45.0179 7.45663C57.875 18.5506 60.4889 38.092 52.0808 51.4158Z",
    stroke: "#5A42ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector24);
export default __webpack_public_path__ + "static/media/Vector-24.c43d02b6b00b7b80af4dbc9878ea3097.svg";
export { ForwardRef as ReactComponent };